var t=t=>t?.status;export{t as getErrorStatus};
//# sourceMappingURL=getErrorStatus.js.map